import { render, staticRenderFns } from "./post-employee.vue?vue&type=template&id=14b0d040&scoped=true"
import script from "./post-employee.vue?vue&type=script&lang=js"
export * from "./post-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0d040",
  null
  
)

export default component.exports